import React from 'react';
import  "./Navbar.scss";
import logo from "../../images/logo.png";
import {CgProfile} from "react-icons/cg";
import {VscSearch} from "react-icons/vsc";
const Navbar = () => {
    return (
        <>
            <div className="navbar">
                <img src={logo} alt="logo" />
                <div className="icon-wrapper">
                  <div className="cgprofile"><CgProfile className="cprofile"/></div>  
                  <div className="vscsearch"><VscSearch className="cprofile"/></div>  
                </div>
            </div>
        </>
    )
}

export default Navbar
